import { Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import Checkbox from "components/atoms/Checkbox/Checkbox";

function AdditionalDetailField() {
  const intl = useIntl();
  const { watch } = useFormContext();

  return (
    <div className="request-row d-flex additional-info-container">
      <Col xs={3}>
        <div className="font-weight-bold font-b1 mb-1">
          <FormattedMessage id="report.additionalDetails" defaultMessage="Additional details" />
        </div>
        <div className="font-b3 text-secondary">
          <FormattedMessage id="report.chooseAdditionalFilters" defaultMessage="Choose additional filters" />
        </div>
      </Col>
      <Col xs={9}>
        <Checkbox
          checkboxLabel={intl.formatMessage({
            id: "report.includeNotYetQuoted",
            defaultMessage: "Include not (yet) quoted",
          })}
          name="include_not_quoted"
          checked={watch("include_not_quoted")}
          providerSections
        />
        <div className="mt-md">
          <Checkbox
            checkboxLabel={intl.formatMessage({
              id: "report.includeDeclined",
              defaultMessage: "Include declined",
            })}
            name="include_declined"
            checked={watch("include_declined")}
            providerSections
          />
        </div>
      </Col>
    </div>
  );
}

export default AdditionalDetailField;
